import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;

  Components.addType("reliable-track", {
    isComponent: (el) => {
      if (
        el.className &&
        typeof el.className === "string" &&
        el.className.includes("track")
      ) {
        return {
          type: "reliable-track",
        };
      }
    },
    model: {
      defaults: {
        tagName: "main",
        attributes: {
          class: "flex-1 flex items-center justify-center track",
        },
        components: html`
          <div class="container mx-auto md:px-12 my-10 md:my-12 px-4">
            <p class="md:text-lg font-semibold  text-center">
              Tracking ID/ Order Number*
            </p>
            <div
              class="flex w-full justify-center text-white items-center flex-col rounded gap-4 md:gap-x-4 max-w-4xl mx-auto  px-4  bg-[#0083D7] py-4 "
            >
              <form id="track-form" class="w-full">
                <div class=" w-full  flex gap-x-2">
                  <input
                    type="text"
                    name="search"
                    id="tracking-number"
                    placeholder="Enter your tracking number, (+977)mobile number or reference number"
                    class="outline-none px-4 py-2 w-full rounded bg-white text-black "
                  />
                  <button
                    type="submit"
                    class="px-4 py-2 w-24 bg-[#FA6914] h-[40px] mb-auto rounded ripple-effect overflow-hidden relative cursor-pointer"
                  >
                    Track
                  </button>
                </div>
              </form>
            </div>
            <div
              id="order-details"
              class="hidden md:mt-6 mt-2 max-w-4xl mx-auto"
            >
              <div class="flex justify-around text-3xl font-bold my-2">
                <div class="text-lg md:text-2xl">
                  <p id="pickup-branch">Butwal</p>
                </div>
                <div class="text-lg md:text-2xl">---------</div>
                <div class="text-lg md:text-2xl">
                  <p id="destination">Baglung</p>
                </div>
              </div>

              <div class="relative w-full max-w-5xl mx-auto pt-10">
                <div
                  class="absolute top-1/2 left-0 w-full h-1 bg-gray-300 rounded-full -translate-y-1/2"
                ></div>

                <div
                  id="progress-fill"
                  class="absolute top-1/2 left-0 h-1 bg-[#fa6914] rounded-full -translate-y-1/2 transition-all duration-500 w-0 z-0"
                ></div>

                <div
                  class="absolute top-1/2 w-full flex justify-between items-center -translate-y-1/2 z-10 px-[8px]"
                >
                  <div
                    id="dot-0"
                    class="w-6 h-6 rounded-full bg-[#fa6914] flex items-center justify-center text-white text-sm"
                  ></div>
                  <div
                    id="dot-1"
                    class="w-6 h-6 rounded-full bg-[#fa6914] flex items-center justify-center text-white text-sm"
                  ></div>
                  <div
                    id="dot-2"
                    class="w-6 h-6 rounded-full bg-[#fa6914] flex items-center justify-center text-white text-sm"
                  ></div>
                  <div
                    id="dot-3"
                    class="w-6 h-6 rounded-full bg-[#fa6914] flex items-center justify-center text-white text-sm"
                  ></div>
                  <div
                    id="dot-4"
                    class="w-6 h-6 rounded-full bg-[#fa6914] flex items-center justify-center text-white text-sm"
                  ></div>
                </div>

                <div
                  class="flex justify-between mt-8 text-sm text-gray-700 font-medium"
                >
                  <div class="w-1/5 ">Shipment Booked</div>
                  <div class="w-1/5 text-center">Shipment Finalized</div>
                  <div class="w-1/5 text-center">Transit</div>
                  <div class="w-1/5 text-center">Out for Delivery</div>
                  <div class="w-1/5 text-right">Delivered</div>
                </div>
              </div>

              <div
                id="order-tracking"
                class="hidden gap-y-2 md:gap-x-6 md:mt-6 mt-2 max-w-5xl mx-auto "
              >
                <div class="text-lg font-bold">
                  <p>Shipment Updates</p>
                  <div
                    id="order-history"
                    class="flex flex-col  mt-6 max-h-[40svh] overflow-y-auto"
                  >
                    <div class="overflow-x-auto">
                      <table
                        class="min-w-full border border-gray-300 text-sm text-left"
                      >
                        <thead>
                          <tr
                            class="text-gray-700 bg-gray-200 whitespace-nowrap"
                          >
                            <th class="px-4 py-2">Date/Time</th>
                            <th class="px-4 py-2 ">Location</th>
                            <th class="px-4 py-2 ">Activity</th>
                            <th class="px-4 py-2 ">Notes</th>
                            <th class="px-4 py-2">Enter By</th>
                            <th class="px-4 py-2">Received</th>
                            <th class="px-4 py-2 ">Sent</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="px-4 py-2">1</td>
                            <td class="px-4 py-2">Birtamode</td>
                            <td class="px-4 py-2">Ganesh Gautam</td>
                            <td class="px-4 py-2">9852677355</td>
                            <td class="px-4 py-2">9852677355</td>
                            <td class="px-4 py-2">9852677355</td>
                            <td class="px-4 py-2">9852677355</td>
                          </tr>
                          <tr>
                            <td class="px-4 py-2">2</td>
                            <td class="px-4 py-2">Damak</td>
                            <td class="px-4 py-2">Padam Adhikari</td>
                            <td class="px-4 py-2">9808585075</td>
                          </tr>
                          <tr>
                            <td class="px-4 py-2">3</td>
                            <td class="px-4 py-2">Itahari</td>
                            <td class="px-4 py-2">Suraj Koirala</td>
                            <td class="px-4 py-2">9802723882</td>
                          </tr>
                          <tr>
                            <td class="px-4 py-2">4</td>
                            <td class="px-4 py-2">Biratnagar</td>
                            <td class="px-4 py-2">Diran Dev</td>
                            <td class="px-4 py-2">9842465252</td>
                          </tr>
                          <tr>
                            <td class="px-4 py-2">5</td>
                            <td class="px-4 py-2">Lahan</td>
                            <td class="px-4 py-2">Rajkumar Yadav</td>
                            <td class="px-4 py-2">9842826494</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class=" md:mt-6 mt-2">
                  <div
                    class="md:text-lg w-full font-bold whitespace-nowrap flex items-center justify-between cursor-pointer"
                    data-toggle-shipment
                  >
                    <span>Shipment Details</span>

                    <svg
                      data-arrow-icon
                      class="w-5 h-5 transition-transform duration-300 transform"
                      fill="#000000"
                      height="24px"
                      width="24px"
                      viewBox="0 0 492.432 492.432"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M142.238,492.432c-9.79,0-19.588-3.736-27.05-11.209c-14.945-14.934-14.945-39.162,0-54.098l180.9-180.909
           l-180.9-180.91c-14.945-14.935-14.945-39.163,0-54.098c14.926-14.944,39.172-14.944,54.098,0l207.96,207.958
           c14.943,14.935,14.943,39.164,0,54.1l-207.96,207.957C161.824,488.697,152.026,492.432,142.238,492.432z"
                      />
                    </svg>
                  </div>
                  <div
                    data-shipment-details
                    class="hidden transition-all duration-300"
                  >
                    <div
                      class="flex justify-between md:gap-x-6 flex-col md:grid md:grid-cols-2 gap-y-2 mt-2"
                    >
                      <div class="whitespace-nowrap flex flex-col gap-y-2">
                        <p id="no-of-boxes">No. of Boxes:</p>
                        <p id="chargable-weight">Chargable Weight:</p>
                        <p id="weight">Net Weight:</p>
                        <p id="reference-no">Reference Number:</p>
                      </div>
                      <div class="whitespace-nowrap flex flex-col gap-y-2">
                        <p id="service-type">Service Type:</p>
                        <p id="tearms">Terms:</p>
                        <p id="dimensions">Dimensions:</p>
                        <p id="forwarding-no">Forwarding Number:</p>
                      </div>
                    </div>
                    <div class="p-1 mt-2">
                      <p id="delivery-instruction">Special Instruction:</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `,
        script: function () {
          const form = document.querySelector("#track-form") as HTMLFormElement;
          const urlParams = new URLSearchParams(window.location.search);
          const trackingNumber = urlParams.get("search");

          const trackingInput = document.querySelector(
            "input[name='search']"
          ) as HTMLInputElement;
          if (trackingInput && trackingNumber) {
            trackingInput.value = trackingNumber;
          }

          function updateOrderDetails(data) {
            document.getElementById(
              "no-of-boxes"
            ).textContent = `No. of Boxes: ${data.children.length}`;
            document.getElementById(
              "pickup-branch"
            ).textContent = `${data.sender.country}`;
            document.getElementById(
              "destination"
            ).textContent = `${data.receiver.country}`;
            document.getElementById(
              "weight"
            ).textContent = `Net Weight: ${data.weight} Kgs`;
            document.getElementById(
              "chargable-weight"
            ).textContent = `Chargable Weight: ${data.charge_wt} Kgs`;
            document.getElementById(
              "service-type"
            ).textContent = `Service Type: ${data.service_type}`;
            document.getElementById(
              "tearms"
            ).textContent = `Terms: ${data.duty_tax_type}`;
            const dimensionsText = data.children
              .map((d) => `${d.length}x${d.breadth}x${d.height}`)
              .join(", ");
            document.getElementById(
              "dimensions"
            ).textContent = `Dimensions: ${dimensionsText}`;
            document.getElementById(
              "reference-no"
            ).textContent = `Reference Number: ${data?.reference_number ?? ""}`;
            document.getElementById(
              "forwarding-no"
            ).textContent = `Forwarding Number: ${data?.forwarding_no ?? ""}`;
            document.getElementById(
              "delivery-instruction"
            ).innerHTML = `Special Instruction: <span class="font-semibold">${
              data?.delivery_instruction ?? ""
            }</span>`;
            document.getElementById("order-details").classList.remove("hidden");
          }
          function updateOrderHistory(historyData) {
            const tbody = document.querySelector("#order-history tbody");
            tbody.innerHTML = "";
            historyData.forEach((item) => {
              const historyItem = document.createElement("tr");
              historyItem.innerHTML = `
                <td class="px-4 py-2">
                  ${new Date(item.created).toLocaleString()}
                </td>
                <td class="px-4 py-2">${item.extra_data?.location ?? ""}</td>
                <td class="px-4 py-2">${item.new_data}</td>
                <td class="px-4 py-2">${item.extra_data?.note ?? ""}</td>
                <td class="px-4 py-2">${item.extra_data?.enter_by ?? ""}</td>
                <td class="px-4 py-2 whitespace-nowrap">${
                  item.extra_data?.receive_date ?? ""
                }</td>
                <td class="px-4 py-2 whitespace-nowrap">${
                  item.extra_data?.sent_date ?? ""
                }</td>
              `;
              tbody.appendChild(historyItem);
              document
                .getElementById("order-tracking")
                .classList.remove("hidden");
            });
          }

          function updateShipmentProgress(currentStatus) {
            const statusSteps = [
              "Shipment Booked",
              "Shipment Finalized",
              "Transit",
              "Out for Delivery",
              "Delivered",
            ];

            const index = statusSteps.indexOf(currentStatus);
            if (index === -1) return;

            const progressPercentage = (index / (statusSteps.length - 1)) * 100;
            document.getElementById(
              "progress-fill"
            ).style.width = `${progressPercentage}%`;

            statusSteps.forEach((_, i) => {
              const dot = document.getElementById(`dot-${i}`);
              if (dot) {
                dot.innerHTML = "";
                dot.className =
                  "w-6 h-6 rounded-full bg-[#fa6914] flex items-center justify-center text-white text-sm transition-all";
              }
            });
            const activeDot = document.getElementById(`dot-${index}`);
            if (activeDot) {
              activeDot.innerHTML = "✈️";
              activeDot.className =
                "w-10 h-10 rounded-full bg-white border-2 border-[#fa6914] flex items-center justify-center text-green-600 text-sm relative overflow-hidden transition-all";
            }
          }

          let progressData;
          function getProgressIndex(progressData, currentLabel) {
            return progressData.findIndex((step) =>
              step.status?.some(
                (stat) => stat.name.toLowerCase() === currentLabel.toLowerCase()
              )
            );
          }

          function handleGetProgressStatus(callback) {
            fetch(
              "https://apiservice.careinfosolutions.com/apiservice/api/v1/public/project-settings/?parent__slug=website-tracking",
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              }
            )
              .then((response) => {
                if (!response.ok) {
                  return response
                    .json()
                    .then(() => Promise.reject("Tracking order failed"));
                }
                return response.json();
              })
              .then((result) => {
                callback(result);
              })
              .catch((error) => {
                console.error("Error fetching progress data:", error);
              });
          }

          handleGetProgressStatus(function (data) {
            progressData = data;
          });

          const handleTrack = function (data: any) {
            fetch(
              "https://prodenvservice.careinfosolutions.com/apiservice/track-order/",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
              }
            )
              .then(function (response) {
                if (!response.ok) {
                  return response.json().then((data) => {
                    showToast(data?.message || "Tracking order failed", "red");
                    document
                      .getElementById("order-details")
                      .classList.add("hidden");
                    document
                      .getElementById("order-tracking")
                      .classList.add("hidden");
                    return Promise.reject("Tracking order failed");
                  });
                }
                return response.json();
              })
              .then(function (result) {
                const index = getProgressIndex(
                  progressData,
                  result.order.status
                );

                if (index !== -1) {
                  const stepName = progressData[index].name;
                  updateShipmentProgress(stepName);
                } else {
                  console.warn(
                    "No matching progress step found for:",
                    result.order.status
                  );
                }
                updateOrderDetails(result.order);
                updateOrderHistory(result.history);
                showToast("Success ", "green");
              })
              .catch(function (error) {
                console.error("Error submitting checkout:", error);
              });
          };

          const handleGetDeliveryInfo = function (data: any) {
            fetch(
              "https://prodenvservice.careinfosolutions.com/apiservice/order-rider-info/",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
              }
            )
              .then(function (response) {
                if (!response.ok) {
                  return response.json().then((data) => {
                    document
                      .getElementById("delivery-info")
                      .classList.add("hidden");
                    return Promise.reject("Tracking order failed");
                  });
                }
                return response.json();
              })
              .then(function (result) {
                return result;
              })
              .catch(function (error) {
                console.error("Error submitting checkout:", error);
              });
          };

          if (form && trackingNumber) {
            handleTrack({ search: trackingNumber });
            handleGetDeliveryInfo({ search: trackingNumber });
          }
          document
            .querySelectorAll("[data-toggle-shipment]")
            .forEach((toggle) => {
              const details = toggle.parentElement.querySelector(
                "[data-shipment-details]"
              );
              const arrow = toggle.querySelector("[data-arrow-icon]");

              toggle.addEventListener("click", () => {
                const isHidden = details.classList.contains("hidden");

                details.classList.toggle("hidden");

                if (isHidden) {
                  arrow.classList.add("rotate-90");
                } else {
                  arrow.classList.remove("rotate-90");
                }
              });
            });

          let validator;
          const initLib = function () {
            //@ts-ignore
            validator = new JustValidate(form);
            validator.addField(document.querySelector("#tracking-number"), [
              {
                rule: "required",
                errorMessage: "Tracking number  is required",
              },
            ]);
          };
          const initToastLib = function () {};
          const showToast = function (toastMessage, color) {
            //@ts-ignore
            Toastify({
              text: `${toastMessage}`,
              duration: 2000,
              close: false,
              gravity: "top",
              position: "right",
              stopOnFocus: true,
              offset: {
                x: 20,
                y: 60,
              },
              style: {
                background: `${color}`,
              },
            }).showToast();
          };

          form.addEventListener("submit", function (e) {
            e.preventDefault();
            const formData = new FormData(form);
            const data: any = {};
            formData.forEach((value, key) => {
              data[key] = value;
            });
            validator.onSuccess((isValid) => {
              if (!isValid) {
                console.log("Form validation failed.");
                return;
              }
              handleTrack(data);
              handleGetDeliveryInfo(data);
            });
          });
          //@ts-ignore
          if (typeof Toastify === "undefined") {
            const script = document.createElement("script");
            script.onload = initToastLib;
            script.src = "https://cdn.jsdelivr.net/npm/toastify-js";
            document.body.appendChild(script);
          } else {
            initToastLib();
          }
          //@ts-ignore
          if (typeof JustValidate === "undefined") {
            const script = document.createElement("script");
            script.onload = initLib;
            script.src =
              "https://unpkg.com/just-validate@latest/dist/just-validate.production.min.js";
            document.body.appendChild(script);
          } else {
            initLib();
          }
        },
      },
    },
  });
};
